export interface BackgroundTaskStatus<
  ErrorType = SerializableValidationResult[],
> {
  taskId: string
  totalItems: number
  processedItems: number
  phase: BackgroundTaskPhase
  successfullyProcessedItems: string[]
  errors: ErrorType
  resourceUrl: string | null
}

export enum BackgroundTaskPhase {
  InProgress = 0,
  Completed = 1,
  Cancelled = 2,
}

// Members
export interface SerializableValidationResult {
  memberNames: string[]
  errorMessage: string
}
